import { KeycloakTokenParsed } from 'keycloak-js'

export const hasUserRole = (
	tokenParsed: KeycloakTokenParsed | undefined,
	role: string,
): boolean => {
	const roles = tokenParsed?.realm_access?.roles ?? []
	return roles.includes(role)
}

export const hasAiAccess = (
	tokenParsed: KeycloakTokenParsed | undefined,
): boolean => {
	return hasUserRole(tokenParsed, 'FEAT_AI')
}

export const hasDiagramAccess = (
	tokenParsed: KeycloakTokenParsed | undefined,
): boolean => {
	return hasUserRole(tokenParsed, 'FEAT_DIAGRAM')
}
